module.exports = __webpack_public_path__ + "static/media/jacktop.0940067c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/games/jacktop.jpg
// module id = 2400
// module chunks = 7